<script setup lang="ts">
import { WhereActive } from '@precon-tools-suite-by-shared/precon-graphql-types';
import { useVModel } from '@vueuse/core';
import { useI18n } from 'vue-i18n';

const props = withDefaults(
    defineProps<{
        modelValue: WhereActive | null | undefined;
    }>(),
    {
        modelValue: undefined,
    }
);

const emit = defineEmits<{
    (e: 'update:modelValue', value: WhereActive | null | undefined): void;
}>();

const { t } = useI18n();

const modelValue = useVModel(props, 'modelValue', emit);

const options = [WhereActive.Only, WhereActive.With, WhereActive.Without];
</script>
<template>
    <div
        v-for="option in options"
        :key="option"
        class="flex gap-2"
        style="margin-bottom: 2px"
    >
        <RadioButton v-model="modelValue" :input-id="option" :value="option" />
        <label :for="option">{{ t(option) }}</label>
    </div>
    <!-- <Button label="maakt niet uit" @click="modelValue = undefined" /> -->
</template>
<i18n>
    {
        "en": {
            "no-products-found": "No products found",
        },
        "nl": {
            "ONLY": "Alleen actieve",
            "WITH": "Actieve en inactieve",
            "WITHOUT": "Alleen inactieve"
        },
        "fr": {
            "no-products-found": "Aucun produit trouvé",
        }
    }
    </i18n>
